import React from 'react';
import { SignIn } from '@clerk/clerk-react';

export default function LoginScreen() {
  return (
    <div style={styles.page}>
      <div style={styles.left}>
        <div style={styles.brandWrap}>
          <div style={styles.logoMark}>m</div>
          <div>
            <h1 style={styles.brandTitle}>másquemuros</h1>
            <span style={styles.brandSub}>architecture studio</span>
          </div>
        </div>

        <div style={styles.tagline}>
          <h2 style={styles.taglineTitle}>Bienvenido de nuevo</h2>
          <p style={styles.taglineBody}>
            Inicia sesión para acceder al panel del estudio — proyectos, cronogramas y
            comunicación del equipo en un solo lugar.
          </p>
        </div>

        <div style={styles.leftFooter}>© {new Date().getFullYear()} másquemuros</div>
      </div>

      <div style={styles.right}>
        <div style={styles.cardWrap}>
          <SignIn
            routing="hash"
            appearance={{
              variables: {
                colorPrimary: '#6B1C2A',
                colorText: '#2a1a1a',
                colorBackground: '#ffffff',
                colorInputBackground: '#fbf7f1',
                colorInputText: '#2a1a1a',
                borderRadius: '10px',
                fontFamily: "'DM Sans', sans-serif",
              },
              elements: {
                rootBox: { width: '100%' },
                card: {
                  boxShadow: '0 20px 60px rgba(74, 18, 32, 0.08)',
                  border: '1px solid rgba(107, 28, 42, 0.08)',
                  borderRadius: 16,
                },
                headerTitle: {
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: 28,
                  fontWeight: 600,
                },
                formButtonPrimary: {
                  background: 'linear-gradient(180deg, #6B1C2A 0%, #4A1220 100%)',
                  fontWeight: 600,
                  textTransform: 'none',
                  letterSpacing: 0,
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    fontFamily: "'DM Sans', sans-serif",
  },
  left: {
    flex: '0 0 42%',
    background: 'linear-gradient(180deg, #6B1C2A 0%, #4A1220 100%)',
    color: '#fff',
    padding: '48px 56px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  brandWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  logoMark: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: 'rgba(201,169,110,0.2)',
    border: '1.5px solid rgba(201,169,110,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 26,
    fontWeight: 700,
    color: '#C9A96E',
    fontStyle: 'italic',
  },
  brandTitle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 22,
    fontWeight: 600,
    letterSpacing: '0.02em',
    margin: 0,
    lineHeight: 1.2,
  },
  brandSub: {
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: '0.18em',
    color: 'rgba(255,255,255,0.5)',
    fontWeight: 500,
  },
  tagline: {
    maxWidth: 440,
  },
  taglineTitle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 44,
    fontWeight: 500,
    margin: '0 0 16px',
    lineHeight: 1.15,
  },
  taglineBody: {
    fontSize: 15,
    lineHeight: 1.6,
    color: 'rgba(255,255,255,0.75)',
    margin: 0,
  },
  leftFooter: {
    fontSize: 12,
    color: 'rgba(255,255,255,0.4)',
    letterSpacing: '0.05em',
  },
  right: {
    flex: 1,
    background: 'var(--beige, #F5EFE5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
  },
  cardWrap: {
    width: '100%',
    maxWidth: 420,
  },
};
